import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  constructor() {}

  /**
   * Vérifie si l'application est en mode production
   */
  isProduction(): boolean {
    return environment.production;
  }

  /**
   * Vérifie si l'application est en mode développement
   */
  isDevelopment(): boolean {
    return !environment.production;
  }

  /**
   * Obtient l'URL de l'API
   */
  getApiUrl(): string {
    return environment.apiUrl;
  }

  /**
   * Obtient le nom de l'application
   */
  getAppName(): string {
    return environment.appName;
  }

  /**
   * Obtient la version de l'application
   */
  getVersion(): string {
    return environment.version;
  }

  /**
   * Obtient la configuration d'authentification
   */
  getAuthConfig() {
    return environment.auth;
  }

  /**
   * Obtient la configuration des uploads
   */
  getUploadConfig() {
    return environment.upload;
  }

  /**
   * Obtient la configuration des notifications
   */
  getNotificationConfig() {
    return environment.notifications;
  }

  /**
   * Obtient la configuration des features
   */
  getFeaturesConfig() {
    return environment.features;
  }

  /**
   * Obtient le timeout HTTP
   */
  getHttpTimeout(): number {
    return environment.httpTimeout;
  }

  /**
   * Obtient la configuration des retry
   */
  getRetryConfig() {
    return {
      maxRetries: environment.maxRetries,
      retryDelay: environment.retryDelay,
    };
  }

  /**
   * Obtient la configuration des logs
   */
  getLogConfig() {
    return {
      enableLogs: environment.enableLogs,
      logLevel: environment.logLevel,
    };
  }

  /**
   * Vérifie si une feature est activée
   */
  isFeatureEnabled(featureName: keyof typeof environment.features): boolean {
    return environment.features[featureName];
  }

  /**
   * Obtient la clé de stockage du token
   */
  getTokenKey(): string {
    return environment.auth.tokenKey;
  }

  /**
   * Obtient la clé de stockage du refresh token
   */
  getRefreshTokenKey(): string {
    return environment.auth.refreshTokenKey;
  }

  /**
   * Obtient la clé de stockage de l'expiration du token
   */
  getTokenExpiryKey(): string {
    return environment.auth.tokenExpiryKey;
  }

  /**
   * Obtient l'URL de téléchargement App Store (page /liens)
   */
  getAppStoreUrl(): string {
    const url = (environment as Record<string, unknown>)['appStoreUrl'];
    return typeof url === 'string' ? url : '';
  }

  /**
   * Obtient l'URL de téléchargement Google Play (page /liens)
   */
  getPlayStoreUrl(): string {
    const url = (environment as Record<string, unknown>)['playStoreUrl'];
    return typeof url === 'string' ? url : '';
  }
}
